import React from 'react';

import { useService } from '@xstate/react';

import { productBuilderMachine } from '../../../../../context/ProductBuilder/machine';
import { Shutters76mmClearViewFaceFit } from './Shutters76mmClearViewFaceFit';
import { Shutters76mmClearviewMidRailRevealFit } from './Shutters76mmClearviewMidRailRevealFit';
import { Shutters76mmClearviewRevealFit } from './Shutters76mmClearviewRevealFit';
import { Shutters76mmClearViewMidRailFaceFit } from './Shutters76mmMidRailClearViewFaceFit';
import { Shutters76mmMidrailTiltControlFaceFit } from './Shutters76mmMidRailTiltControlFaceFit';
import { Shutters76mmMidrailTiltControlRevealFit } from './Shutters76mmMidrailTiltControlRevealFit';
import { Shutters76mmTiltControlFaceFit } from './Shutters76mmTiltControlFaceFit';
import { Shutters76mmClearviewTiltControlRevealFit } from './Shutters76mmTiltControlRevealFit';

interface ShuttersProps extends React.SVGProps<SVGSVGElement> {
  patternUrl: string;
}

export const Shutters76 = ({ patternUrl, ...props }: ShuttersProps) => {
  const [state] = useService(productBuilderMachine);
  const operation =
    state.context.custom.operation === 'Control Bar'
      ? 'Control Bar'
      : 'Clear View';

  const fitting = state.context.custom.fitting;

  const [width, height] = state.context.custom.measurements
    ? (state.context.custom.measurements as string)
        .split('x')
        .map(value => parseInt(value))
    : ['', ''];

  if (
    operation === 'Control Bar' &&
    (height === '' || height <= 2030) &&
    fitting === 'Face Fit'
  ) {
    return (
      <Shutters76mmTiltControlFaceFit patternUrl={patternUrl} {...props} />
    );
  } else if (
    operation !== 'Control Bar' &&
    height > 2034 &&
    fitting === 'Reveal Fit'
  ) {
    return (
      <Shutters76mmClearviewMidRailRevealFit
        patternUrl={patternUrl}
        {...props}
      />
    );
  } else if (
    operation !== 'Control Bar' &&
    height > 2030 &&
    fitting === 'Face Fit'
  ) {
    return (
      <Shutters76mmClearViewMidRailFaceFit patternUrl={patternUrl} {...props} />
    );
  } else if (
    operation === 'Control Bar' &&
    height > 2034 &&
    fitting === 'Reveal Fit'
  ) {
    return (
      <Shutters76mmMidrailTiltControlRevealFit
        patternUrl={patternUrl}
        {...props}
      />
    );
  } else if (
    operation === 'Control Bar' &&
    (height === '' || height <= 2034) &&
    fitting === 'Reveal Fit'
  ) {
    return (
      <Shutters76mmClearviewTiltControlRevealFit
        patternUrl={patternUrl}
        {...props}
      />
    );
  } else if (
    operation !== 'Control Bar' &&
    (height === '' || height <= 2030) &&
    fitting === 'Face Fit'
  ) {
    return <Shutters76mmClearViewFaceFit patternUrl={patternUrl} {...props} />;
  } else if (
    operation === 'Control Bar' &&
    height > 2030 &&
    fitting === 'Face Fit'
  ) {
    return (
      <Shutters76mmMidrailTiltControlFaceFit
        patternUrl={patternUrl}
        {...props}
      />
    );
  } else if (
    operation !== 'Control Bar' &&
    (height === '' || height <= 2034) &&
    fitting === 'Reveal Fit'
  ) {
    return (
      <Shutters76mmClearviewRevealFit patternUrl={patternUrl} {...props} />
    );
  } else if (
    operation !== 'Control Bar' &&
    height > 2030 &&
    fitting === 'Face Fit'
  ) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 555.2 410"
        preserveAspectRatio="none"
        {...props}
      >
        <defs>
          <pattern
            id="shutters76"
            patternUnits="userSpaceOnUse"
            width="100"
            height="100"
          >
            <image href={patternUrl} x="0" y="0" width="100" height="100" />
          </pattern>
        </defs>
        <defs>
          <linearGradient
            id="prefix__linear-gradient"
            x1={405.67}
            y1={-75.06}
            x2={405.67}
            y2={-70.9}
            gradientTransform="matrix(1 0 0 -1 .5 -19.61)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0.02} stopColor="#fff" stopOpacity={0.5} />
            <stop offset={0.37} stopOpacity={0} />
            <stop offset={1} stopOpacity={0.6} />
          </linearGradient>
          <linearGradient
            id="prefix__linear-gradient-2"
            x1={405.67}
            y1={-99.73}
            x2={405.67}
            y2={-95.58}
            xlinkHref="#prefix__linear-gradient"
          />
          <linearGradient
            id="prefix__linear-gradient-3"
            x1={405.67}
            y1={-124.41}
            x2={405.67}
            y2={-120.26}
            xlinkHref="#prefix__linear-gradient"
          />
          <linearGradient
            id="prefix__linear-gradient-4"
            x1={405.67}
            y1={-149.09}
            x2={405.67}
            y2={-144.93}
            xlinkHref="#prefix__linear-gradient"
          />
          <linearGradient
            id="prefix__linear-gradient-5"
            x1={405.67}
            y1={-173.76}
            x2={405.67}
            y2={-169.61}
            xlinkHref="#prefix__linear-gradient"
          />
          <linearGradient
            id="prefix__linear-gradient-6"
            x1={405.67}
            y1={-198.44}
            x2={405.67}
            y2={-194.29}
            xlinkHref="#prefix__linear-gradient"
          />
          <linearGradient
            id="prefix__linear-gradient-7"
            x1={405.67}
            y1={-254.93}
            x2={405.67}
            y2={-250.78}
            xlinkHref="#prefix__linear-gradient"
          />
          <linearGradient
            id="prefix__linear-gradient-8"
            x1={405.67}
            y1={-279.61}
            x2={405.67}
            y2={-275.46}
            xlinkHref="#prefix__linear-gradient"
          />
          <linearGradient
            id="prefix__linear-gradient-9"
            x1={405.67}
            y1={-304.29}
            x2={405.67}
            y2={-300.13}
            xlinkHref="#prefix__linear-gradient"
          />
          <linearGradient
            id="prefix__linear-gradient-10"
            x1={405.67}
            y1={-328.96}
            x2={405.67}
            y2={-324.81}
            xlinkHref="#prefix__linear-gradient"
          />
          <linearGradient
            id="prefix__linear-gradient-11"
            x1={405.67}
            y1={-353.64}
            x2={405.67}
            y2={-349.49}
            xlinkHref="#prefix__linear-gradient"
          />
          <linearGradient
            id="prefix__linear-gradient-12"
            x1={405.67}
            y1={-378.32}
            x2={405.67}
            y2={-374.16}
            xlinkHref="#prefix__linear-gradient"
          />
          <linearGradient
            id="prefix__linear-gradient-13"
            x1={40.93}
            y1={-84.73}
            x2={40.93}
            y2={-59.82}
            gradientTransform="matrix(1 0 0 -1 .5 -19.61)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0.24} stopOpacity={0} />
            <stop offset={1} stopOpacity={0.3} />
          </linearGradient>
          <linearGradient
            id="prefix__linear-gradient-14"
            x1={7044.88}
            y1={-84.73}
            x2={7044.88}
            y2={-59.82}
            gradientTransform="rotate(180 3650.795 -9.805)"
            xlinkHref="#prefix__linear-gradient-13"
          />
          <linearGradient
            id="prefix__linear-gradient-15"
            x1={40.93}
            y1={-109.82}
            x2={40.93}
            y2={-84.91}
            xlinkHref="#prefix__linear-gradient-13"
          />
          <linearGradient
            id="prefix__linear-gradient-16"
            x1={7044.88}
            y1={-109.82}
            x2={7044.88}
            y2={-84.91}
            gradientTransform="rotate(180 3650.795 -9.805)"
            xlinkHref="#prefix__linear-gradient-13"
          />
          <linearGradient
            id="prefix__linear-gradient-17"
            x1={40.93}
            y1={-135.09}
            x2={40.93}
            y2={-110.17}
            xlinkHref="#prefix__linear-gradient-13"
          />
          <linearGradient
            id="prefix__linear-gradient-18"
            x1={7044.88}
            y1={-135.09}
            x2={7044.88}
            y2={-110.17}
            gradientTransform="rotate(180 3650.795 -9.805)"
            xlinkHref="#prefix__linear-gradient-13"
          />
          <linearGradient
            id="prefix__linear-gradient-19"
            x1={40.93}
            y1={-160.36}
            x2={40.93}
            y2={-135.45}
            xlinkHref="#prefix__linear-gradient-13"
          />
          <linearGradient
            id="prefix__linear-gradient-20"
            x1={7044.88}
            y1={-160.36}
            x2={7044.88}
            y2={-135.45}
            gradientTransform="rotate(180 3650.795 -9.805)"
            xlinkHref="#prefix__linear-gradient-13"
          />
          <linearGradient
            id="prefix__linear-gradient-21"
            x1={40.93}
            y1={-185.61}
            x2={40.93}
            y2={-160.7}
            xlinkHref="#prefix__linear-gradient-13"
          />
          <linearGradient
            id="prefix__linear-gradient-22"
            x1={7044.88}
            y1={-185.61}
            x2={7044.88}
            y2={-160.7}
            gradientTransform="rotate(180 3650.795 -9.805)"
            xlinkHref="#prefix__linear-gradient-13"
          />
          <linearGradient
            id="prefix__linear-gradient-23"
            x1={40.93}
            y1={-210.89}
            x2={40.93}
            y2={-185.98}
            xlinkHref="#prefix__linear-gradient-13"
          />
          <linearGradient
            id="prefix__linear-gradient-24"
            x1={7044.88}
            y1={-210.89}
            x2={7044.88}
            y2={-185.98}
            gradientTransform="rotate(180 3650.795 -9.805)"
            xlinkHref="#prefix__linear-gradient-13"
          />
          <linearGradient
            id="prefix__linear-gradient-25"
            x1={40.93}
            y1={-263.24}
            x2={40.93}
            y2={-238.33}
            xlinkHref="#prefix__linear-gradient-13"
          />
          <linearGradient
            id="prefix__linear-gradient-26"
            x1={7044.88}
            y1={-263.24}
            x2={7044.88}
            y2={-238.33}
            gradientTransform="rotate(180 3650.795 -9.805)"
            xlinkHref="#prefix__linear-gradient-13"
          />
          <linearGradient
            id="prefix__linear-gradient-27"
            x1={40.93}
            y1={-288.52}
            x2={40.93}
            y2={-263.61}
            xlinkHref="#prefix__linear-gradient-13"
          />
          <linearGradient
            id="prefix__linear-gradient-28"
            x1={7044.88}
            y1={-288.52}
            x2={7044.88}
            y2={-263.61}
            gradientTransform="rotate(180 3650.795 -9.805)"
            xlinkHref="#prefix__linear-gradient-13"
          />
          <linearGradient
            id="prefix__linear-gradient-29"
            x1={40.93}
            y1={-313.8}
            x2={40.93}
            y2={-288.9}
            xlinkHref="#prefix__linear-gradient-13"
          />
          <linearGradient
            id="prefix__linear-gradient-30"
            x1={7044.88}
            y1={-313.8}
            x2={7044.88}
            y2={-288.9}
            gradientTransform="rotate(180 3650.795 -9.805)"
            xlinkHref="#prefix__linear-gradient-13"
          />
          <linearGradient
            id="prefix__linear-gradient-31"
            x1={40.93}
            y1={-339.05}
            x2={40.93}
            y2={-314.13}
            xlinkHref="#prefix__linear-gradient-13"
          />
          <linearGradient
            id="prefix__linear-gradient-32"
            x1={7044.88}
            y1={-339.05}
            x2={7044.88}
            y2={-314.13}
            gradientTransform="rotate(180 3650.795 -9.805)"
            xlinkHref="#prefix__linear-gradient-13"
          />
          <linearGradient
            id="prefix__linear-gradient-33"
            x1={40.93}
            y1={-364.32}
            x2={40.93}
            y2={-339.41}
            xlinkHref="#prefix__linear-gradient-13"
          />
          <linearGradient
            id="prefix__linear-gradient-34"
            x1={7044.88}
            y1={-364.32}
            x2={7044.88}
            y2={-339.41}
            gradientTransform="rotate(180 3650.795 -9.805)"
            xlinkHref="#prefix__linear-gradient-13"
          />
          <linearGradient
            id="prefix__linear-gradient-35"
            x1={40.93}
            y1={-389.59}
            x2={40.93}
            y2={-364.69}
            xlinkHref="#prefix__linear-gradient-13"
          />
          <linearGradient
            id="prefix__linear-gradient-36"
            x1={7044.88}
            y1={-389.59}
            x2={7044.88}
            y2={-364.69}
            gradientTransform="rotate(180 3650.795 -9.805)"
            xlinkHref="#prefix__linear-gradient-13"
          />
          <style>
            {
              '.prefix__cls-2,.prefix__cls-3,.prefix__cls-5,.prefix__cls-8{fill:none;stroke:#4d4d4d;stroke-miterlimit:10}.prefix__cls-2{stroke-width:.95px}.prefix__cls-2,.prefix__cls-3,.prefix__cls-8{opacity:.15;isolation:isolate}.prefix__cls-3{stroke-width:.94px}.prefix__cls-5{stroke-width:.81px}.prefix__cls-6{opacity:.2}.prefix__cls-7{fill:#333}.prefix__cls-8{stroke-width:.83px}'
            }
          </style>
        </defs>
        <path
          d="M.5.5v410h555.2V.5zm514.36 369.63H297.5v-11.47h217.36zm0-15.6H297.5V334h217.36zm0-24.62H297.5v-20.49h217.36zm0-24.72H297.5V284.7h217.36zm0-24.63H297.5V260h217.36zm0-24.71H297.5v-20.49h217.36zm0-24.72H297.5V218.5h217.36zm0-39.66H297.5v-12.6h217.36zm0-16.83H297.5v-20.49h217.36zm0-24.62H297.5V129.5h217.36zm0-24.72H297.5v-20.49h217.36zm0-24.62H297.5V80.09h217.36zm0-24.72H297.5V55.5h217.36zm0-24.62H297.5V39.87h217.36z"
          fill="url(#shutters76)"
          id="prefix__Colour"
        />
        <g id="prefix__Shadow">
          <path className="prefix__cls-2" d="M12.6 12.8h27.53v384.4H12.6z" />
          <path
            className="prefix__cls-3"
            d="M40.11 12.78h217.38v27.07H40.11zM40.13 191.47h217.38v27.07H40.13zM297.48 191.46h217.38v27.07H297.48zM40.16 370.16h217.38v27.07H40.16zM297.46 12.78h217.38v27.07H297.46zM297.51 370.15h217.38v27.07H297.51z"
          />
          <path
            className="prefix__cls-2"
            d="M514.86 12.8h27.53v384.4h-27.53z"
          />
          <g opacity={0.15}>
            <path
              className="prefix__cls-5"
              d="M257.52 12.8h19.98v384.4h-19.98zM277.5 12.8h19.98v384.4H277.5z"
            />
          </g>
          <g className="prefix__cls-6">
            <path
              className="prefix__cls-7"
              d="M12.6 72.39h2.49v35.81H12.6zM12.6 301.8h2.49v35.81H12.6z"
            />
          </g>
          <g className="prefix__cls-6">
            <path
              className="prefix__cls-7"
              d="M539.91 72.39h2.49v35.81h-2.49zM539.91 301.8h2.49v35.81h-2.49z"
            />
          </g>
          <path
            className="prefix__cls-8"
            d="M40.14 39.87h217.38v25.28H40.14z"
          />
          <g opacity={0.54}>
            <path
              fill="url(#prefix__linear-gradient)"
              d="M297.48 51.34h217.38v4.14H297.48z"
            />
            <path
              fill="url(#prefix__linear-gradient-2)"
              d="M297.48 75.96h217.38v4.14H297.48z"
            />
            <path
              fill="url(#prefix__linear-gradient-3)"
              d="M297.48 100.68h217.38v4.14H297.48z"
            />
            <path
              fill="url(#prefix__linear-gradient-4)"
              d="M297.48 125.3h217.38v4.14H297.48z"
            />
            <path
              fill="url(#prefix__linear-gradient-5)"
              d="M297.48 150.02h217.38v4.14H297.48z"
            />
            <path
              fill="url(#prefix__linear-gradient-6)"
              d="M297.48 174.64h217.38v4.14H297.48z"
            />
            <path
              fill="url(#prefix__linear-gradient-7)"
              d="M297.48 231.13h217.38v4.14H297.48z"
            />
            <path
              fill="url(#prefix__linear-gradient-8)"
              d="M297.48 255.85h217.38v4.14H297.48z"
            />
            <path
              fill="url(#prefix__linear-gradient-9)"
              d="M297.48 280.56h217.38v4.14H297.48z"
            />
            <path
              fill="url(#prefix__linear-gradient-10)"
              d="M297.48 305.19h217.38v4.14H297.48z"
            />
            <path
              fill="url(#prefix__linear-gradient-11)"
              d="M297.48 329.91h217.38v4.14H297.48z"
            />
            <path
              fill="url(#prefix__linear-gradient-12)"
              d="M297.48 354.53h217.38v4.14H297.48z"
            />
          </g>
          <path
            className="prefix__cls-8"
            d="M40.14 65.15h217.38v25.28H40.14zM40.14 90.43h217.38v25.28H40.14z"
          />
          <path
            className="prefix__cls-8"
            d="M40.14 115.62h217.38v25.28H40.14zM40.14 140.9h217.38v25.28H40.14zM40.14 166.18h217.38v25.28H40.14zM40.14 218.53h217.38v25.28H40.14zM40.14 243.82h217.38v25.28H40.14zM40.14 269.1h217.38v25.28H40.14zM40.14 294.38h217.38v25.28H40.14z"
          />
          <path
            className="prefix__cls-8"
            d="M40.14 319.57h217.38v25.28H40.14zM40.14 344.85h217.38v25.28H40.14z"
          />
          <path
            fill="url(#prefix__linear-gradient-13)"
            d="M42.24 40.24h-1.63v24.91l1.63-24.91z"
          />
          <path
            fill="url(#prefix__linear-gradient-14)"
            d="M255.9 40.24h1.62v24.91l-1.62-24.91z"
          />
          <path
            fill="url(#prefix__linear-gradient-15)"
            d="M42.24 65.34h-1.63v24.91l1.63-24.91z"
          />
          <path
            fill="url(#prefix__linear-gradient-16)"
            d="M255.9 65.34h1.62v24.91l-1.62-24.91z"
          />
          <path
            fill="url(#prefix__linear-gradient-17)"
            d="M42.24 90.53h-1.63v25l1.63-25z"
          />
          <path
            fill="url(#prefix__linear-gradient-18)"
            d="M255.9 90.53h1.62v25l-1.62-25z"
          />
          <path
            fill="url(#prefix__linear-gradient-19)"
            d="M42.24 115.81h-1.63v24.91l1.63-24.91z"
          />
          <path
            fill="url(#prefix__linear-gradient-20)"
            d="M255.9 115.81h1.62v24.91l-1.62-24.91z"
          />
          <path
            fill="url(#prefix__linear-gradient-21)"
            d="M42.24 141.09h-1.63V166l1.63-24.91z"
          />
          <path
            fill="url(#prefix__linear-gradient-22)"
            d="M255.9 141.09h1.62V166l-1.62-24.91z"
          />
          <path
            fill="url(#prefix__linear-gradient-23)"
            d="M42.24 166.37h-1.63v24.91l1.63-24.91z"
          />
          <path
            fill="url(#prefix__linear-gradient-24)"
            d="M255.9 166.37h1.62v24.91l-1.62-24.91z"
          />
          <path
            fill="url(#prefix__linear-gradient-25)"
            d="M42.24 218.72h-1.63v24.91l1.63-24.91z"
          />
          <path
            fill="url(#prefix__linear-gradient-26)"
            d="M255.9 218.72h1.62v24.91l-1.62-24.91z"
          />
          <path
            fill="url(#prefix__linear-gradient-27)"
            d="M42.24 244h-1.63v24.91L42.24 244z"
          />
          <path
            fill="url(#prefix__linear-gradient-28)"
            d="M255.9 244h1.62v24.91L255.9 244z"
          />
          <path
            fill="url(#prefix__linear-gradient-29)"
            d="M42.24 269.29h-1.63v24.9l1.63-24.9z"
          />
          <path
            fill="url(#prefix__linear-gradient-30)"
            d="M255.9 269.29h1.62v24.9l-1.62-24.9z"
          />
          <path
            fill="url(#prefix__linear-gradient-31)"
            d="M42.24 294.47h-1.63v25l1.63-25z"
          />
          <path
            fill="url(#prefix__linear-gradient-32)"
            d="M255.9 294.47h1.62v25l-1.62-25z"
          />
          <path
            fill="url(#prefix__linear-gradient-33)"
            d="M42.24 319.75h-1.63v24.91l1.63-24.91z"
          />
          <path
            fill="url(#prefix__linear-gradient-34)"
            d="M255.9 319.75h1.62v24.91l-1.62-24.91z"
          />
          <path
            fill="url(#prefix__linear-gradient-35)"
            d="M42.24 345.04h-1.63v24.9l1.63-24.9z"
          />
          <path
            fill="url(#prefix__linear-gradient-36)"
            d="M255.9 345.04h1.62v24.9l-1.62-24.9z"
          />
          <path
            style={{
              isolation: 'isolate',
            }}
            opacity={0.2}
            fill="none"
            stroke="#4d4d4d"
            strokeMiterlimit={10}
            d="M.5.5h555.2v410H.5z"
          />
          <path
            d="M554.7 1.5v408H1.5V1.5h553.2M12.75 398.25H543.5V12.75H12.75v385.5M555.7.5H.5v410h555.2zM13.75 397.25V13.75H542.5v383.5z"
            fill="#4d4d4d"
          />
        </g>
      </svg>
    );
  } else {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 555.2 410.9"
        {...props}
        preserveAspectRatio="none"
      >
        <defs>
          <pattern
            id="shutters76"
            patternUnits="userSpaceOnUse"
            width="100"
            height="100"
          >
            <image href={patternUrl} x="0" y="0" width="100" height="100" />
          </pattern>
        </defs>
        <defs>
          <linearGradient
            id="prefix__linear-gradient"
            x1={41.4}
            y1={931.35}
            x2={41.4}
            y2={904.25}
            gradientTransform="translate(.5 -863.55)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0.24} stopOpacity={0} />
            <stop offset={1} stopOpacity={0.3} />
          </linearGradient>
          <linearGradient
            id="prefix__linear-gradient-2"
            x1={7007.24}
            y1={931.35}
            x2={7007.24}
            y2={904.25}
            gradientTransform="matrix(-1 0 0 1 7263.59 -863.55)"
            xlinkHref="#prefix__linear-gradient"
          />
          <linearGradient
            id="prefix__linear-gradient-3"
            x1={41.4}
            y1={958.75}
            x2={41.4}
            y2={931.65}
            xlinkHref="#prefix__linear-gradient"
          />
          <linearGradient
            id="prefix__linear-gradient-4"
            x1={7007.24}
            y1={958.75}
            x2={7007.24}
            y2={931.65}
            gradientTransform="matrix(-1 0 0 1 7263.59 -863.55)"
            xlinkHref="#prefix__linear-gradient"
          />
          <linearGradient
            id="prefix__linear-gradient-5"
            x1={41.4}
            y1={986.22}
            x2={41.4}
            y2={959.12}
            xlinkHref="#prefix__linear-gradient"
          />
          <linearGradient
            id="prefix__linear-gradient-6"
            x1={7007.24}
            y1={986.22}
            x2={7007.24}
            y2={959.12}
            gradientTransform="matrix(-1 0 0 1 7263.59 -863.55)"
            xlinkHref="#prefix__linear-gradient"
          />
          <linearGradient
            id="prefix__linear-gradient-7"
            x1={41.4}
            y1={1013.7}
            x2={41.4}
            y2={986.6}
            xlinkHref="#prefix__linear-gradient"
          />
          <linearGradient
            id="prefix__linear-gradient-8"
            x1={7007.24}
            y1={1013.7}
            x2={7007.24}
            y2={986.6}
            gradientTransform="matrix(-1 0 0 1 7263.59 -863.55)"
            xlinkHref="#prefix__linear-gradient"
          />
          <linearGradient
            id="prefix__linear-gradient-9"
            x1={41.4}
            y1={1041.15}
            x2={41.4}
            y2={1014.05}
            xlinkHref="#prefix__linear-gradient"
          />
          <linearGradient
            id="prefix__linear-gradient-10"
            x1={7007.24}
            y1={1041.15}
            x2={7007.24}
            y2={1014.05}
            gradientTransform="matrix(-1 0 0 1 7263.59 -863.55)"
            xlinkHref="#prefix__linear-gradient"
          />
          <linearGradient
            id="prefix__linear-gradient-11"
            x1={41.4}
            y1={1068.6}
            x2={41.4}
            y2={1041.5}
            xlinkHref="#prefix__linear-gradient"
          />
          <linearGradient
            id="prefix__linear-gradient-12"
            x1={7007.24}
            y1={1068.6}
            x2={7007.24}
            y2={1041.5}
            gradientTransform="matrix(-1 0 0 1 7263.59 -863.55)"
            xlinkHref="#prefix__linear-gradient"
          />
          <linearGradient
            id="prefix__linear-gradient-13"
            x1={41.4}
            y1={1096.05}
            x2={41.4}
            y2={1068.97}
            xlinkHref="#prefix__linear-gradient"
          />
          <linearGradient
            id="prefix__linear-gradient-14"
            x1={7007.24}
            y1={1096.05}
            x2={7007.24}
            y2={1068.97}
            gradientTransform="matrix(-1 0 0 1 7263.59 -863.55)"
            xlinkHref="#prefix__linear-gradient"
          />
          <linearGradient
            id="prefix__linear-gradient-15"
            x1={41.4}
            y1={1123.5}
            x2={41.4}
            y2={1096.4}
            xlinkHref="#prefix__linear-gradient"
          />
          <linearGradient
            id="prefix__linear-gradient-16"
            x1={7007.24}
            y1={1123.5}
            x2={7007.24}
            y2={1096.4}
            gradientTransform="matrix(-1 0 0 1 7263.59 -863.55)"
            xlinkHref="#prefix__linear-gradient"
          />
          <linearGradient
            id="prefix__linear-gradient-17"
            x1={41.4}
            y1={1150.95}
            x2={41.4}
            y2={1123.85}
            xlinkHref="#prefix__linear-gradient"
          />
          <linearGradient
            id="prefix__linear-gradient-18"
            x1={7007.24}
            y1={1150.95}
            x2={7007.24}
            y2={1123.85}
            gradientTransform="matrix(-1 0 0 1 7263.59 -863.55)"
            xlinkHref="#prefix__linear-gradient"
          />
          <linearGradient
            id="prefix__linear-gradient-19"
            x1={41.4}
            y1={1178.45}
            x2={41.4}
            y2={1151.35}
            xlinkHref="#prefix__linear-gradient"
          />
          <linearGradient
            id="prefix__linear-gradient-20"
            x1={7007.24}
            y1={1178.45}
            x2={7007.24}
            y2={1151.35}
            gradientTransform="matrix(-1 0 0 1 7263.59 -863.55)"
            xlinkHref="#prefix__linear-gradient"
          />
          <linearGradient
            id="prefix__linear-gradient-21"
            x1={41.4}
            y1={1205.92}
            x2={41.4}
            y2={1178.82}
            xlinkHref="#prefix__linear-gradient"
          />
          <linearGradient
            id="prefix__linear-gradient-22"
            x1={7007.24}
            y1={1205.92}
            x2={7007.24}
            y2={1178.82}
            gradientTransform="matrix(-1 0 0 1 7263.59 -863.55)"
            xlinkHref="#prefix__linear-gradient"
          />
          <linearGradient
            id="prefix__linear-gradient-23"
            x1={41.4}
            y1={1233.4}
            x2={41.4}
            y2={1206.3}
            xlinkHref="#prefix__linear-gradient"
          />
          <linearGradient
            id="prefix__linear-gradient-24"
            x1={7007.24}
            y1={1233.4}
            x2={7007.24}
            y2={1206.3}
            gradientTransform="matrix(-1 0 0 1 7263.59 -863.55)"
            xlinkHref="#prefix__linear-gradient"
          />
          <linearGradient
            id="prefix__linear-gradient-25"
            x1={405.4}
            y1={919.82}
            x2={405.4}
            y2={915.2}
            gradientTransform="translate(.5 -863.55)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0.02} stopColor="#fff" stopOpacity={0.5} />
            <stop offset={0.37} stopOpacity={0} />
            <stop offset={1} stopOpacity={0.6} />
          </linearGradient>
          <linearGradient
            id="prefix__linear-gradient-26"
            x1={405.4}
            y1={947.28}
            x2={405.4}
            y2={942.66}
            xlinkHref="#prefix__linear-gradient-25"
          />
          <linearGradient
            id="prefix__linear-gradient-27"
            x1={405.4}
            y1={974.74}
            x2={405.4}
            y2={970.12}
            xlinkHref="#prefix__linear-gradient-25"
          />
          <linearGradient
            id="prefix__linear-gradient-28"
            x1={405.4}
            y1={1002.21}
            x2={405.4}
            y2={997.58}
            xlinkHref="#prefix__linear-gradient-25"
          />
          <linearGradient
            id="prefix__linear-gradient-29"
            x1={405.4}
            y1={1029.67}
            x2={405.4}
            y2={1025.05}
            xlinkHref="#prefix__linear-gradient-25"
          />
          <linearGradient
            id="prefix__linear-gradient-30"
            x1={405.4}
            y1={1057.13}
            x2={405.4}
            y2={1052.51}
            xlinkHref="#prefix__linear-gradient-25"
          />
          <linearGradient
            id="prefix__linear-gradient-31"
            x1={405.4}
            y1={1084.59}
            x2={405.4}
            y2={1079.97}
            xlinkHref="#prefix__linear-gradient-25"
          />
          <linearGradient
            id="prefix__linear-gradient-32"
            x1={405.4}
            y1={1112.06}
            x2={405.4}
            y2={1107.44}
            xlinkHref="#prefix__linear-gradient-25"
          />
          <linearGradient
            id="prefix__linear-gradient-33"
            x1={405.4}
            y1={1139.52}
            x2={405.4}
            y2={1134.89}
            xlinkHref="#prefix__linear-gradient-25"
          />
          <linearGradient
            id="prefix__linear-gradient-34"
            x1={405.4}
            y1={1166.98}
            x2={405.4}
            y2={1162.36}
            xlinkHref="#prefix__linear-gradient-25"
          />
          <linearGradient
            id="prefix__linear-gradient-35"
            x1={405.4}
            y1={1194.44}
            x2={405.4}
            y2={1189.82}
            xlinkHref="#prefix__linear-gradient-25"
          />
          <linearGradient
            id="prefix__linear-gradient-36"
            x1={405.4}
            y1={1221.9}
            x2={405.4}
            y2={1217.28}
            xlinkHref="#prefix__linear-gradient-25"
          />
          <style>
            {
              '.prefix__cls-3{opacity:.2}.prefix__cls-4{fill:#ececec;stroke:gray;stroke-width:.95px;stroke-miterlimit:10}'
            }
          </style>
        </defs>
        <path
          d="M.5.45v409.9h555.2V.45zm297.2 39.7h217.2v11.5H297.7zm0 16.1h217.2v22.8H297.7zm0 27.5h217.2v22.7H297.7zm0 27.3h217.2V134H297.7zm0 27.5h217.2v22.9H297.7zm0 27.5h217.2V189H297.7zm0 27.4h217.2v22.9H297.7zm0 27.5h217.2v22.9H297.7zm0 27.5h217.2v22.9H297.7zm0 27.4h217.2v22.9H297.7zm0 27.4h217.2v22.9H297.7zm0 27.5h217.2v22.9H297.7zm0 27.6h217.2v11.4H297.7z"
          fill="url(#shutters76)"
          id="prefix__Colour"
        />
        <g id="prefix__Shadow">
          <path
            d="M513.9 12.8h-217v.1h-39.1v-.1H12.7v384.5h245.4v-.1h39.1v.1h245.4V12.8zM257.1 94.7h-216V68.1h216zm0 27.5h-216V95.6h216zm0 27.5h-216v-26.6h216zm0 27.5h-216v-26.7h216zm0 27.3h-216v-26.6h216zm0 27.5h-216v-26.5h216zm0 27.5h-216v-26.6h216zm0 27.5h-216v-26.55h216V287zm0 27.4h-216v-26.6h216v26.6zm0 27.5h-216v-26.6h216zM41.1 67.3V40.7h216v26.5h-216zm0 302v-26.5h216v26.5zm216-355.6v26.1h-216V13.7zm-217 382.6H13.6V13.7h26.5zm217 0h-216v-26.1h216zm20 .1H258V13.6h19.1zm236.8-38.6h-216v-3.7h216zm0 1v10.5H297.8v-10.5zm-216.1-5.6v-21.9h216.1v21.9zm216.1-22.7h-216v-3.7h216zm-216.1-4.7V304h216.1v21.9zM513.9 303h-216v-3.8h216zm-216.1-4.7v-21.85h216.1v21.9zm216.1-22.8h-216v-3.7h216zm-216.1-4.6V249h216.1v21.9zM513.9 248h-216v-3.7h216zm-216.1-4.55v-21.9h216.1v21.9zm216.1-22.8h-216V217h216zm-216.1-4.6v-21.9h216.1v21.9zm216.1-22.9h-216v-3.7h216zm-216.1-4.6v-21.9h216.1v21.9zm216.1-22.9h-216V162h216zm-216.1-4.6v-21.9h216.1v21.9zm216.1-22.9h-216v-3.6h216zm-216.1-4.6v-21.8h216.1v21.9l-216.1-.1zm216.1-22.7h-216v-3.8h216zm-216.1-4.7v-22h216.1V106l-216.1.1zm216.1-22.8h-216v-3.7h216zm-216.1-4.7V56.8h216.1v21.9l-216.1-.1zm216.1-22.8h-216v-3.7h216zm-216.1-4.6V40.7h216.1v10.5zm.1-37.5h216v26.1h-216v-26.1zm-20 382.7V13.6H297v27.1h.1v10.5h-.1v5.5h.1v21.9h-.1v5.5h.1v21.8h-.1v5.55h.1v22.1h-.1v5.5h.1V161h-.1v5.5h.1v22.1h-.1v5.5h.1V216h-.1v5.5h.1v21.9h-.1v5.5h.1v21.9h-.1v5.5h.1v21.8h-.1v5.5h.1v21.9h-.1v5.5h.1v21.9h-.1v5.5h.1v10.5h-.1v27.5zm20-.1v-26.1h216v26.1zm243.5 0h-26.5V13.7h26.5z"
            style={{
              isolation: 'isolate',
            }}
            opacity={0.2}
            fill="#4d4d4d"
          />
          <g className="prefix__cls-3">
            <path
              className="prefix__cls-4"
              d="M13.6 72.7h2.5v35.7h-2.5zM13.6 301.6h2.5v35.7h-2.5z"
            />
          </g>
          <g className="prefix__cls-3">
            <path
              className="prefix__cls-4"
              d="M539.4 72.7h2.5v35.7h-2.5zM539.4 301.6h2.5v35.7h-2.5z"
            />
          </g>
          <path
            fill="url(#prefix__linear-gradient)"
            d="M42.7 40.7h-1.6v27.1l1.6-27.1z"
          />
          <path
            fill="url(#prefix__linear-gradient-2)"
            d="M255.6 40.7h1.5v27.1l-1.5-27.1z"
          />
          <path
            fill="url(#prefix__linear-gradient-3)"
            d="M42.7 68.1h-1.6v27.1l1.6-27.1z"
          />
          <path
            fill="url(#prefix__linear-gradient-4)"
            d="M255.6 68.1h1.5v27.1l-1.5-27.1z"
          />
          <path
            fill="url(#prefix__linear-gradient-5)"
            d="M42.7 95.6h-1.6v27.1l1.6-27.1z"
          />
          <path
            fill="url(#prefix__linear-gradient-6)"
            d="M255.6 95.6h1.5v27.1l-1.5-27.1z"
          />
          <path
            fill="url(#prefix__linear-gradient-7)"
            d="M42.7 123h-1.6v27.1l1.6-27.1z"
          />
          <path
            fill="url(#prefix__linear-gradient-8)"
            d="M255.6 123h1.5v27.1l-1.5-27.1z"
          />
          <path
            fill="url(#prefix__linear-gradient-9)"
            d="M42.7 150.5h-1.6v27.1l1.6-27.1z"
          />
          <path
            fill="url(#prefix__linear-gradient-10)"
            d="M255.6 150.5h1.5v27.1l-1.5-27.1z"
          />
          <path
            fill="url(#prefix__linear-gradient-11)"
            d="M42.7 178h-1.6v27.1l1.6-27.1z"
          />
          <path
            fill="url(#prefix__linear-gradient-12)"
            d="M255.6 178h1.5v27.1l-1.5-27.1z"
          />
          <path
            fill="url(#prefix__linear-gradient-13)"
            d="M42.7 205.5h-1.6v27l1.6-27z"
          />
          <path
            fill="url(#prefix__linear-gradient-14)"
            d="M255.6 205.5h1.5v27l-1.5-27z"
          />
          <path
            fill="url(#prefix__linear-gradient-15)"
            d="M42.7 232.8h-1.6v27.1l1.6-27.1z"
          />
          <path
            fill="url(#prefix__linear-gradient-16)"
            d="M255.6 232.8h1.5v27.1l-1.5-27.1z"
          />
          <path
            fill="url(#prefix__linear-gradient-17)"
            d="M42.7 260.3h-1.6v27.1l1.6-27.1z"
          />
          <path
            fill="url(#prefix__linear-gradient-18)"
            d="M255.6 260.3h1.5v27.1l-1.5-27.1z"
          />
          <path
            fill="url(#prefix__linear-gradient-19)"
            d="M42.7 287.8h-1.6v27.1l1.6-27.1z"
          />
          <path
            fill="url(#prefix__linear-gradient-20)"
            d="M255.6 287.8h1.5v27.1l-1.5-27.1z"
          />
          <path
            fill="url(#prefix__linear-gradient-21)"
            d="M42.7 315.3h-1.6v27.1l1.6-27.1z"
          />
          <path
            fill="url(#prefix__linear-gradient-22)"
            d="M255.6 315.3h1.5v27.1l-1.5-27.1z"
          />
          <path
            fill="url(#prefix__linear-gradient-23)"
            d="M42.7 342.7h-1.6v27.1l1.6-27.1z"
          />
          <path
            fill="url(#prefix__linear-gradient-24)"
            d="M255.6 342.7h1.5v27.1l-1.5-27.1z"
          />
          <g opacity={0.54}>
            <path
              fill="url(#prefix__linear-gradient-25)"
              d="M297.4 51.7h217v4.6h-217z"
            />
            <path
              fill="url(#prefix__linear-gradient-26)"
              d="M297.4 79.1h217v4.6h-217z"
            />
            <path
              fill="url(#prefix__linear-gradient-27)"
              d="M297.4 106.5h217v4.6h-217z"
            />
            <path
              fill="url(#prefix__linear-gradient-28)"
              d="M297.4 134h217v4.6h-217z"
            />
            <path
              fill="url(#prefix__linear-gradient-29)"
              d="M297.4 161.5h217v4.6h-217z"
            />
            <path
              fill="url(#prefix__linear-gradient-30)"
              d="M297.4 189h217v4.6h-217z"
            />
            <path
              fill="url(#prefix__linear-gradient-31)"
              d="M297.4 216.4h217v4.6h-217z"
            />
            <path
              fill="url(#prefix__linear-gradient-32)"
              d="M297.4 243.9h217v4.6h-217z"
            />
            <path
              fill="url(#prefix__linear-gradient-33)"
              d="M297.4 271.4h217v4.6h-217z"
            />
            <path
              fill="url(#prefix__linear-gradient-34)"
              d="M297.4 298.8h217v4.6h-217z"
            />
            <path
              fill="url(#prefix__linear-gradient-35)"
              d="M297.4 326.2h217v4.6h-217z"
            />
            <path
              fill="url(#prefix__linear-gradient-36)"
              d="M297.4 353.7h217v4.6h-217z"
            />
          </g>
          <path
            style={{
              isolation: 'isolate',
            }}
            fill="none"
            stroke="#4d4d4d"
            strokeMiterlimit={10}
            opacity={0.2}
            d="M.5.5h555.2v409.9H.5z"
          />
          <path
            d="M554.7 1.5v408H1.5V1.5zM12.8 398.1h530.7V12.7H12.8zM555.7.5H.5v410h555.2zM13.8 397.1V13.7h528.7v383.4z"
            fill="#4d4d4d"
          />
        </g>
      </svg>
    );
  }
};
